export enum ErrorCode {
  DEFAULT = 'default',
  DUPLICATE_PROFILE = 'duplicate_profile',
  HOST_NOT_FOUND = 'host_not_found',
  BAD_INTEGRATION_CONFIGURATION = 'bad_integration_configuration',
  VISIT_NOT_CREATED = 'visit_not_created',
}
